module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_0_1.106f11a4.png";